module.exports = __webpack_public_path__ + "img/@roll_left.5044de98.svg";